import { BIRD_EYE_API_KEY } from "@/utils";
import axios from "axios";

const BIRDEYE_TOKEN_METADATA_SINGLE_URL =
    "https://public-api.birdeye.so/defi/v3/token/meta-data/single";

interface FetchTokenPriceProps {
    tokenAddress: string;
    chain?: string;
}
interface TokenMetadata {
    address: string;
    symbol: string;
    name: string;
    logo_uri: string;
    decimals: number;
    price: number;
    marketCap: number;
}

export const getTokenMetaDataBirdEyeSingle = async ({
    tokenAddress,
    chain = "solana",
}: FetchTokenPriceProps): Promise<TokenMetadata> => {
    try {
        const metadataRequests = await axios.get(BIRDEYE_TOKEN_METADATA_SINGLE_URL, {
            params: { address: tokenAddress },
            headers: {
                "X-API-KEY": BIRD_EYE_API_KEY,
                accept: "application/json",
                "x-chain": chain,
            },
        });

        return metadataRequests.data.data;
    } catch (error) {
        console.error("Error fetching token metadata:", error);
        throw error;
    }
};
